module.exports = __webpack_public_path__ + "img/8-min.7b14a8d0.jpg";